var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Features = OCS.Viewer.Features || {};
OCS.Viewer.Classes.AbstractFeature = new Class({
    Implements: [Options, Events, OCS.Viewer.Classes.OlObject, OCS.Viewer.Classes.OlEvent],
    class_type: "Feature",
    class_name: "AbstractFeature",
    update_timeout: null,
    bound_methods: {},
    options: {
        type: 'Feature',
        properties: {
            dataset: '',
        },
        geometry: {type: "Polygon", coordinates: []},

    },
    active: true,
    geometry: {},
    initialize: function (op) {
        if (!this.options.id) {
            this.options.id = this.get_id();
        } else {
            // We have an existing feature that has already been stored
            //return OCS.Viewer.Features[this.options.properties.id]
        }
        this.setOptions(op);
        this.addEvent('update', this.on_update.bind(this));
        this.addEvent('changed', this.on_changed.bind(this));
        this.addEvent('highlight', this.on_highlight.bind(this));
        this.addEvent('select', this.on_select.bind(this));
        //OCS.Viewer.Features[this.options.properties.id] = this;

    },
    /*
     * 
     * Action methods
     * 
     */

    create: function () {
        //if (this.options.geometry) {
        // Remove any events tied to the original feature
        this.remove_all_events();
        if(this.geometry && Object.keys(this.geometry).length) {
            // Create the feature
            var feature = new ol.Feature({geometry: this.geometry});
            feature.setProperties(this.options.properties);
            this.set_ol_object(feature);
            this.changed();
        } else {
            return false;
        }
        return true;
    },


    /*
     * 
     * Event Fires
     * 
     */
    highlight: function (condition) {
        this.fireEvent('highlight', condition, 1);
    },
    select: function (condition) {
        this.fireEvent('select', condition, 1);
    },
    changed: function () {
        this.fireEvent('changed', this, 1);
    },
    update: function () {
        if (!this.update_timeout) {
            this.update_timeout = setTimeout(function () {
                this.fireEvent('update', this);
                this.update_timeout = null;
            }.bind(this), 50);
        }
    },

    /*
     * 
     * Event Listeners
     * 
     */
    on_changed: function () {
        var feature_obj = this.get_ol_object();
        feature_obj.changed();
    },

    on_highlight: function (condition) {
        var feature_obj = this.get_ol_object();
        feature_obj.set('is_highlighted', condition);
    },
    on_select: function (condition) {
        var feature_obj = this.get_ol_object();
        feature_obj.set('is_selected', condition);
    },
    on_update: function () {
        var feature_obj = this.get_ol_object();
        if (!feature_obj) {
            this.create();
        } else {
            feature_obj.setGeometry(this.geometry);
            feature_obj.setProperties(this.options.properties);
            this.changed();
        }
    },

    /*
     * 
     * Getter / Setters
     * 
     */
    get_active: function() {
        var ol_obj = this.get_ol_object();
        if(ol_obj) {
            return ol_obj.get('active');
        }
        return false;
    },
    set_active: function(cond) {
        var ol_obj = this.get_ol_object();
        if(ol_obj) {
            ol_obj.set('active', cond);
        }
        return cond;
    },
    get_is_selected: function() {
        var feature_obj = this.get_ol_object();
        return feature_obj.get('is_selected');
    },
    get_feature: function () {
        return this.get_ol_object();
    },
    set_feature_from_geojson: function(geojson) {
        this.set_properties(geojson.properties);
        var format = new ol.format.GeoJSON();
        var dataProjection = OCS.Viewer.Config.default_display_projection;
        if(geojson.crs) {
            dataProjection = geojson.crs.properties.name;
            delete geojson.crs;
        }

        var feature = format.readFeature(geojson, {"dataProjection": dataProjection, "featureProjection": OCS.Viewer.Config.default_projection});
        var geom = feature.getGeometry();
        if(geom.getCoordinates && geom.getCoordinates().length && ol.extent.getArea(geom.getExtent()) > 0) {
            this.set_geometry(geom);
        }
    },
    set_geometry: function (geom) {
        if(geom.type && geom.coordinates) {
            geom = new ol.geom[geom.type](geom.coordinates);
        }

        var test1, test2;
        test1 = JSON.stringify(geom.getCoordinates());
        if(this.geometry && this.geometry.getCoordinates) {
            test2 = JSON.stringify(this.geometry.getCoordinates());
        }

        if (test1 !== test2) {
            this.geometry = geom;
            this.update();
        }
    },
    set_properties: function (props) {
        if (!props) {
            return;
        }

        var test1 = JSON.stringify(props);
        var test2 = JSON.stringify(this.options.properties);
        if (test1 !== test2) {
            this.options.properties = props;
            this.update();
        }
    },
    /*
     * Delete and destroy methods
     */

    delete: function () {
        this.fireEvent('destroyed', this);
        this.removeEvents();
        delete this.options;

    }
});

